var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"bg-grey-lighten-1"},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('p',{staticClass:"pa-0 ma-0"},[_c('a',{staticClass:"text-decoration-none typography2--text",attrs:{"href":"/privacy"}},[_vm._v("Privacy Policy")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }